import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import invoiceDesign1 from "../Assets/Design/invoice design1.png";
import lkiLogo from "../Assets/Design/LKI-logo.png";
import "./SampleInvoice.scss";

function SampleInvoice() {
  const exportPDF = () => {
    const invoice = document.getElementById("invoice");

    html2canvas(invoice, {
      backgroundColor: "#ffffff", // FIX BLUE TINT
      useCORS: true, // FIX TRANSPARENT PNG COLOR ISSUES
      scale: 2, // HIGHER RESOLUTION
    }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png");
      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      pdf.save("invoice.pdf");
    });
  };

  const exportJPG = () => {
    const invoice = document.getElementById("invoice");

    html2canvas(invoice, {
      backgroundColor: "#ffffff",
      useCORS: true,
      scale: 2,
    }).then((canvas) => {
      const link = document.createElement("a");
      link.download = "invoice.jpg";
      link.href = canvas.toDataURL("image/jpeg");
      link.click();
    });
  };

  return (
    <div>
      <div className="invoice" id="invoice">
        <img className="invoice-design1" src={invoiceDesign1} alt="" />

        <div className="content-container">
          <img src={lkiLogo} alt="LKI Logo" />
          <h1>INVOICE</h1>
          <h3>HI LITTLE KID INSIDE!</h3>
          <span>
            Thank you for your patience, your ordered item/s below can be
            shipped starting on <b>SUNDAY, November 23</b>:
          </span>
          <div className="table-container">
            <table>
              <thead>
                <tr>
                  <th>ITEMS</th>
                  <th>QTY</th>
                  <th>Balance</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>NARUTO SHIPPUDEN SOFT VINYL FIGURE-GAMABUNTA</td>
                  <td>1</td>
                  <td>800</td>
                </tr>

                <tr>
                  <td>AMAZING HEROES-PLUS-ENDEAVOR</td>
                  <td>1</td>
                  <td>690</td>
                </tr>

                <tr className="total">
                  <td colSpan={2}>Total:</td>
                  <td>1490</td>
                </tr>
              </tbody>
            </table>
          </div>
          <p>
            {`Kindly settle your balance on or before `}
            <b>October 27, 2024</b>
            {` to avoid automatic cancellation of order and downpayment forfeiture. 

Please let us know if you'd like to use Lalamove, LBC, or Shopee checkout before the shipping date (since the next shipping date will probably  will a week after). If you'd prefer to store your items and wait for additional items before shipping, kindly inform us a day before the shipping date.



`}
          </p>
          |<p>{process.env.NODE_ENV}</p>
        </div>
        <span className="thankyou">THANK YOU!</span>
        <img className="invoice-design2" src={invoiceDesign1} alt="" />
      </div>

      <div style={{ textAlign: "center", marginTop: "20px" }}>
        <button onClick={exportPDF} style={{ marginRight: "10px" }}>
          Download PDF
        </button>
        <button onClick={exportJPG}>Download JPG</button>
      </div>
    </div>
  );
}

export default SampleInvoice;
